import type { Expect } from '@quromedical/utils';
import type { Extension } from 'fhir/r4';

import { ExtensionUrl } from './url';

/**
 * List of keys for which the expected value for every given extension should be stored
 */
export const extensionKeys = {
  // address
  [ExtensionUrl.addressEmergencyAccess]: 'valueString',
  [ExtensionUrl.addressGooglePlaceId]: 'valueString',
  [ExtensionUrl.addressLatitude]: 'valueDecimal',
  [ExtensionUrl.addressLongitude]: 'valueDecimal',

  // patient
  [ExtensionUrl.riskClassification]: 'valueString',
  [ExtensionUrl.admissionICD10Code]: 'valueCoding',
  [ExtensionUrl.medicalAidAuthorizationCode]: 'valueIdentifier',
  [ExtensionUrl.latestStatus]: 'valueCode',

  // practitioner
  [ExtensionUrl.initialGroup]: 'valueReference',
  [ExtensionUrl.medicationRequestPrescriber]: 'valueBoolean',

  // clinical impression
  [ExtensionUrl.clinicalImpressionNoteCode]: 'valueCode',
  [ExtensionUrl.clinicalImpressionLocationCode]: 'valueCode',
  [ExtensionUrl.clinicalImpressionAssessmentCode]: 'valueCode',
  [ExtensionUrl.clinicalImpressionPlanCode]: 'valueCode',
  [ExtensionUrl.clinicalImpressionPinned]: 'valueBoolean',
  [ExtensionUrl.clinicalImpressionStructuredContentJSON]: 'valueString',
  [ExtensionUrl.clinicalImpressionSummarySection]: 'valueString',

  // observation
  [ExtensionUrl.observationComponentDateTime]: 'valueDateTime',
  [ExtensionUrl.observationComponentSensorId]: 'valueString',

  // extension to any resource at the top-level
  [ExtensionUrl.practitionerToNotify]: 'valueReference',

  // encounter
  [ExtensionUrl.encounterOxygenRate]: 'valueQuantity',
  [ExtensionUrl.encounterAttachment]: 'valueReference',
  [ExtensionUrl.encounterHospitalizationAuthorizationDate]: 'valueDate',
  [ExtensionUrl.encounterHospitalizationDependentCode]: 'valueString',
  [ExtensionUrl.encounterHospitalizationSchemeCode]: 'valueString',
  [ExtensionUrl.encounterHospitalizationSubscriberId]: 'valueString',

  // supplyDelivery
  [ExtensionUrl.supplyDeliveryTransportCost]: 'valueMoney',
  [ExtensionUrl.supplyDeliveryTransportCostFactor]: 'valueDecimal',

  // claim
  [ExtensionUrl.claimItemChargeItemDefinition]: 'valueReference',

  // claimResponseItemTraceNumber
  [ExtensionUrl.claimResponseItemTraceNumber]: 'valueString',

  // medicationUsage
  [ExtensionUrl.medicationUsageGroupIdentifier]: 'valueString',

  // money
  [ExtensionUrl.moneyFactor]: 'valueDecimal',

  // Encounter
  [ExtensionUrl.encounterPrimaryIcd10Code]: 'valueBoolean',

  // Service Request
  [ExtensionUrl.serviceRequestCopyPractitioners]: 'valueReference',

  // Task
  [ExtensionUrl.TaskRequestedPeriod]: 'valuePeriod',
  [ExtensionUrl.TaskRequestedPerformer]: 'valueReference',

  //Observation
  [ExtensionUrl.observationReferenceRangeComparator]: 'valueString',

  // RiskAssessment
  [ExtensionUrl.riskAssessmentRiskScore]: 'valueDecimal',

  //Flag
  [ExtensionUrl.flagNote]: 'valueString',

  //Teleco,
  [ExtensionUrl.whatsappEnabled]: 'valueBoolean',

  /**
   * @deprecated this search extension is no longer in use
   */
  [ExtensionUrl.assignedOrganization]: 'valueReference',
} as const;

/**
 * The type to be used for the extension keys. This will resolve to `unknown` if the `extensionKeys`
 * does not correctly implement `Record<ExtensionUrl, keyof Extension>` fully
 */
export type ExtensionKeys = Expect<
  typeof extensionKeys extends Record<ExtensionUrl, keyof Extension>
    ? typeof extensionKeys
    : unknown
>;
